import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../features/Home/Home";
import ProjetsPage from "../features/Projects/Projects";
import AboutPage from "../features/About/About";
import ServicesPage from "../features/Services/Services";
import PrivacyPolicyPage from "../features/PrivacyPolicy/PrivacyPolicy";
import NotFound from "../features/NotFound/NotFound";
import ScrollToTop from "../ScrollToTop/ScrollToTop";

const ResponsiveRouter = () => {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/projects" element={<ProjetsPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
}

export default ResponsiveRouter;
